module.exports = __webpack_public_path__ + "img/sunmi@2x.d95f1208.png";